export enum MoneyPropertyEnum {
  AMOUNT = 'amount',
  CURRENCY = 'currency',
}
